import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from 'store/types/root';
import translate from 'translate';
import clsx from 'clsx';
import OnboardinPopupCarousel from '../../Carousels/OnboardinPopupCarousel';
import OnBoardingPopupShimmerLoading from '../../Loading/OnboardingPopupShimmerLoader';
import styles from './styles.module.scss';

const OnBoardingModal = ({ hideModal }: { hideModal: () => void }) => {
  const { loading, infoPopup } = useSelector(
    (state: IRootState) => state.onboardingPopup
  );
  // The onboarding entry can be missing for a locale (204 from the endpoint);
  // dismiss instead of rendering an empty modal.
  const hasPages = Boolean(infoPopup?.pages?.length);

  useEffect(() => {
    if (!loading && !hasPages) {
      hideModal();
    }
  }, [loading, hasPages, hideModal]);

  if (!loading && !hasPages) {
    return null;
  }

  return (
    <section
      className={styles.carousel}
      aria-label={translate('Onboarding_HowToPortal')}
      aria-roledescription="carousel"
      aria-live="polite"
    >
      <button
        className={clsx(styles.closeButton)}
        disabled={loading}
        onClick={hideModal}
      >
        {translate('General_Skip')}
      </button>
      {loading ? (
        <OnBoardingPopupShimmerLoading />
      ) : (
        <OnboardinPopupCarousel hideModal={hideModal} />
      )}
    </section>
  );
};

export default OnBoardingModal;
